import { Directive, HostListener } from '@angular/core';

/**
 * Allows the aside to be toggled via click.
 */
@Directive({
  selector: '[hbAppAsideMenuToggler]',
})
export class AsideToggleDirective {
  constructor() {}

  @HostListener('click', ['$event'])
  toggleOpen($event: any) {
    $event.preventDefault();
    document.querySelector('body').classList.toggle('aside-menu-hidden');
    document.getElementById('aside-menu').classList.toggle('showing');
    document
      .getElementById('notification-toast')
      .firstElementChild.classList.toggle('toast-margin');
  }
}
